export const problemWithPathEdges = [
  {
    id: "2.133.220.187-102.80.143.201",
    source: "2.133.220.187",
    target: "102.80.143.201",
    type: "straight",
  },
  {
    id: "10.5.112.134-71.20.12.201",
    source: "71.20.12.201",
    target: "10.5.112.134",
    type: "straight",
  },
  {
    id: "10.5.112.134-102.80.143.201",
    source: "10.5.112.134",
    target: "102.80.143.201",
    type: "straight",
  },
  {
    id: "10.5.112.134-25.44.79.53",
    source: "10.5.112.134",
    target: "25.44.79.53",
    type: "straight",
  },
  {
    id: "71.20.12.201-135.156.222.108",
    source: "71.20.12.201",
    target: "135.156.222.108",
    type: "straight",
  },
  {
    id: "10.5.112.134-172.251.238.79",
    source: "10.5.112.134",
    target: "172.251.238.79",
    type: "straight",
  },
  {
    id: "48.189.46.255-159.199.179.144",
    source: "48.189.46.255",
    target: "159.199.179.144",
    type: "straight",
  },
  {
    id: "159.199.179.144-174.175.243.159",
    source: "159.199.179.144",
    target: "174.175.243.159",
    type: "straight",
  },
  {
    id: "48.189.46.255-174.175.243.159",
    source: "48.189.46.255",
    target: "174.175.243.159",
    type: "straight",
  },
  {
    id: "48.189.46.255-51.247.206.27",
    source: "48.189.46.255",
    target: "51.247.206.27",
    type: "straight",
  },
  {
    id: "102.80.143.201-194.200.5.136",
    source: "102.80.143.201",
    target: "194.200.5.136",
    type: "straight",
  },
];
